

export function Note({ 
	small = false, 
	children 
}) {
	return <p className={small ? 'small' : ''}><em>Note:</em> {children}</p>
}